import { combineReducers } from 'redux';

import channels from '@store/reducers/channels';
import ux from '@store/reducers/ux';

export default combineReducers({
  channels,
  ux,
});
